<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <!-- Placeholder for potential compnay icon
         <b-link class="navbar-brand" to="#"> -->
      <!-- </b-link> -->
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <!-- This is needed for some reason... -->
        <LanguagesDropdown type="b-nav-item-dropdown"/>
      </b-navbar-nav>
      <b-button @click="attemptLogout"><i class="fa fa-lock"/> Logout</b-button>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
      </AppSidebar>
      <main class="main">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" :key="index" v-for="(routeObject, index) in routeRecords">
            <span class="active" v-if="index === routeRecords.length - 1">{{ routeObject.label }}</span>
            <router-link :to="routeObject.to" v-else>{{ routeObject.label }}</router-link>
          </li>
        </ol>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import {
  Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader,
  SidebarNav
} from '@coreui/vue';
import { mapGetters, mapActions } from 'vuex';
import LanguagesDropdown from '@/containers/Dropdowns/LanguagesDropdown';
import _nav from '@/_nav';
import VT from '@/store/types';

export default {
  name: 'DefaultContainer',
  beforeMount() {
    if (!this.token) {
      this.$router.push({ name: 'Login' });
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    LanguagesDropdown
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('Auth', [
      'token', 'user', 'permissions'
    ]),
    nav() {
      return JSON.parse(JSON.stringify(_nav)).items.filter((item) => this.navItemAvailable(item)).map((item) => this.navItemMap(item));
    },
    name() {
      return this.$route.name;
    },
    routeRecords() {
      return this.$route.matched.filter((route) => route.name || route.meta.label).map((route) => {
        return {
          label: this.$t(route.meta.label),
          to: route.path
        };
      });
    }
  },
  methods: {
    ...mapActions('Auth', [
      VT.LOGOUT,
    ]),
    hasAccess(requiredPermissions) {
      if (requiredPermissions) {
        return requiredPermissions.filter((permission) => this.permissions.includes(permission)).length > 0;
      }
      return true;
    },
    navItemAvailable(item) {
      if (!this.hasAccess(item.permissions)) return false;
      if (item.disableOffline && this.isOffline) return false; // hide when offline
      return true;
    },
    attemptLogout: async function () {
      this.$ability.update([]);
      await this.LOGOUT();
      await this.$store.dispatch(VT.RESET_TO_DEFAULT_STATE, []);
      this.$router.push({ name: 'Login' });
    },
    navItemMap(item) {
      item.children = !item.children ? undefined : item.children.filter(
        (child) => this.navItemAvailable(child)
      ).map(
        (child) => this.navItemMap(child)
      );
      item.name = this.$t(item.name);
      // item.attributes = { disabled: item.disableOffline && this.isOffline }; // modify when offline
      return item;
    }
  },
};
</script>
